import React, {useState} from 'react';
import {FtDialog} from "@/common/FtDialog";
import {FtButton} from "@/common/FtButton";
import {ApiClient} from "@/api/ApiClient";
import {useAsyncEffect} from "@/hook/useAsyncEffect";
import {useDeleteTransaction, useUpdateTransaction} from "@/hook/useTransactions";
import {ErrorUtil} from "@/utils/ErrorUtil";
import {TransactionForm} from "@/component/form/TransactionForm";
import {TransData} from "@/common/dto/TransData";
import {TransUtils} from "@/utils/TransUtils";
import {LoadableView} from "@/component/view/LoadableView";

interface Props {
    transId: number;
    handleClose: () => void;
}

export function EditTransDialog(props: Props) {
    const {transId} = props;
    const updateTransaction = useUpdateTransaction();
    const deleteTransaction = useDeleteTransaction();

    const [data, setData] = useState<Partial<TransData> | undefined>();

    const error = useAsyncEffect(async () => {
        const trans = await ApiClient.instance.getTransaction(transId);
        setData({
            transactDate: trans.transactDate,
            amount: trans.amount,
            detail: trans.detail,
            inAccountId: trans.inAccountId,
            outAccountId: trans.outAccountId,
        });
    }, [transId]);

    async function deleteAction() {
        if (!confirm("정말로 삭제할까요?")) return;

        try {
            await deleteTransaction.mutateAsync(transId);
            props.handleClose();
        } catch (e) {
            alert("ERROR: " + ErrorUtil.getErrorMessage(e));
        }
    }

    const editAction = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!data) return;
        try {
            await updateTransaction.mutateAsync({
                transId,
                req: TransUtils.validateTransData(data),
            });
            props.handleClose();
        } catch (e) {
            alert("ERROR: " + ErrorUtil.getErrorMessage(e));
        }
    };

    return <FtDialog handleClose={props.handleClose} title="거래건 수정">
        <LoadableView data={data} error={error} component={(data) => (
            <form onSubmit={editAction}>
                <TransactionForm data={data} setData={setData} />

                <div style={{display: "flex", justifyContent: "flex-end", marginTop: "16px", gap: 8}}>
                    <FtButton type="button" variant="outlined" onClick={deleteAction}>삭제</FtButton>
                    <FtButton type="submit" variant="contained" disabled={!data.inAccountId || !data.outAccountId || data.amount === undefined}>수정</FtButton>
                </div>
            </form>
        )}/>
    </FtDialog>
}